import * as React from "react"

import { Consumer } from "./Context"

import { getPosition } from "./utils"

class Droppable extends React.Component {
    onDragLeave = () => this.props.context.onDragLeave(this)
    onDragOver = event => {
        if (!this.props.context.isActive) {
            return
        }
        if (this.props.context.dragPayload.id === this.props.payload.id) {
            return
        }

        event.persist()
        let position
        if (this.props.dimensional) {
            position = getPosition(
                {
                    target: event.target.parentElement,
                    clientX: event.clientX,
                    clientY: event.clientY,
                },
                this.props.dimensional
            )
        } else position = this.props.position

        this.props.context.onDragOver(this, position, this.props.payload)

        event.preventDefault()
        event.stopPropagation()
    }
    onDrop = event => {
        if (!this.props.context.isActive) {
            return
        }
        event.preventDefault()
        event.stopPropagation()

        this.props.context.onDrop(this)
    }
    getPropsAndState = () => {
        return {
            isDraggingOver: this.props.context.isOver(this),
            getRootProps: ({ className = "" } = {}) => ({
                className:
                    className +
                    (this.props.context.isOver(this)
                        ? " isDraggingOver " + this.props.context.position
                        : ""),
                onDragOver: this.onDragOver,
                onDragLeave: this.onDragLeave,
                onDragEnd: () => console.log("dragend"),
                onDrop: this.onDrop,
            }),
        }
    }
    render() {
        if (!this.props.context || !this.props.context.onDragLeave) {
            throw new Error(
                "DragDropContext not found, please add <DragDropContext> on top on Droppable"
            )
        }
        return this.props.children(this.getPropsAndState())
    }
}

export default function DroppableWithContext(props) {
    return <Consumer>{context => <Droppable context={context} {...props} />}</Consumer>
}



// WEBPACK FOOTER //
// ./src/features/editor/dnd/Droppable.js